import type { IvSmileType } from './types';

export const IV_SMILE_TYPES: IvSmileType[] = [
  { id: 'overbite', label: 'Overbite', image: '/invisalign/overbite.png' },
  { id: 'underbite', label: 'Underbite', image: '/invisalign/underbite.png' },
  { id: 'crossbite', label: 'Crossbite', image: '/invisalign/crossbite.png' },
  { id: 'gap-teeth', label: 'Gap teeth', image: '/invisalign/gap-teeth.png' },
  { id: 'open-bite', label: 'Open bite', image: '/invisalign/open bite.png' },
  { id: 'crooked-teeth', label: 'Crooked teeth', image: '/invisalign/crooked-teeth.png' },
  {
    id: 'generally-straight',
    label: 'Generally straight',
    image: '/invisalign/generally-straight.png',
  },
  {
    id: 'mixed-baby-teeth',
    label: 'Mixed baby teeth',
    image: '/invisalign/mixed-baby-teeth.png',
  },
];
